import React from 'react';
import MagicLinkConsumeScreen from '../../../src/screens/auth/MagicLinkConsumeScreen';

export default function MagicLinkRoute() {
  return <MagicLinkConsumeScreen />;
}
